import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { Toaster } from '../ui/sonner';
import { CustomScripts } from '../CustomScripts';

export const PublicLayout = () => {
  return (
    <div className="min-h-screen bg-sios-void flex flex-col">
      <CustomScripts />
      <Navbar />
      <main className="flex-1 pt-20">
        <Outlet />
      </main>
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
};
